import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { Heart, Map, Grid3X3, Trophy, Info } from 'lucide-react';
import { motion } from 'framer-motion';
import { cityConfig } from '@/config/cities';

const Layout = () => {
  const location = useLocation();
  const gridLabel = cityConfig.totalHearts <= 100 ? '1-100' : '1-1000';

  const navItems = [
    { to: '/', icon: Heart, label: 'Accueil', fill: true },
    { to: '/grid', icon: Grid3X3, label: gridLabel, fill: false },
    { to: '/map', icon: Map, label: 'Carte', fill: false },
    { to: '/leaderboard', icon: Trophy, label: 'Top', fill: false },
    { to: '/about', icon: Info, label: 'Info', fill: false },
  ];

  return (
    <div className="min-h-screen bg-black overflow-x-hidden" data-testid="layout">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-center">
          <NavLink to="/" className="flex items-center gap-2" data-testid="logo-link">
            <Heart className="w-5 h-5 text-[#E63946] heart-pulse" fill="#E63946" />
            <span className="font-display font-bold text-base sm:text-lg tracking-tight uppercase">
              <span className="text-white">HE</span><span className="text-[#E63946]">ART</span><span className="text-white">S</span><span className="text-[#A1A1AA]"> IN {cityConfig.name.toUpperCase()}</span>
            </span>
          </NavLink>
        </div>
      </header>

      {/* Main content */}
      <div className="pt-14 pb-20">
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
        >
          <Outlet />
        </motion.div>
      </div>

      {/* Bottom Navigation Bar — always on top */}
      <nav
        className="fixed bottom-0 left-0 right-0 z-[9999] bg-black border-t border-white/5"
        data-testid="bottom-nav"
      >
        <div className="max-w-md mx-auto flex items-center justify-around py-2 px-1" style={{ paddingBottom: 'max(8px, env(safe-area-inset-bottom))' }}>
          {navItems.map(({ to, icon: Icon, label, fill: shouldFill }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `flex flex-col items-center gap-0.5 px-1.5 py-1 transition-all duration-200 ${
                  isActive
                    ? 'text-[#E63946]'
                    : 'text-[#71717A] hover:text-[#A1A1AA]'
                }`
              }
              data-testid={`nav-${label.toLowerCase().replace(/\s/g, '-')}`}
            >
              {({ isActive }) => (
                <>
                  <Icon
                    className="w-4 h-4"
                    fill={isActive && shouldFill ? '#E63946' : 'none'}
                  />
                  <span className="text-[9px] font-semibold tracking-wide uppercase leading-none">{label}</span>
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
};

export default Layout;
